import { NavLink, useNavigate } from 'react-router-dom';
import style from './SidePanel.module.css';

const SidePanel = () => {

    const navigate = useNavigate();

    return (
        <div className={ style.sidePanel } >
            <img
                src='/Images/Logo.png'
                alt='logo-palmont'
                className={ style.imageLogo }
                onClick={ () => navigate( "/Home" ) }
            />

            <div className={ style.menuList } >
                <NavLink to="ghe-funcoes" >
                    {({ isActive }) => (
                        <div className={ isActive ? style.menuItemActive : style.menuItem } > <p> GHE - FUNÇÕES </p></div>
                    )}
                </NavLink>
                <NavLink to="exames-ghe" >
                    {({ isActive }) => (
                        <div className={ isActive ? style.menuItemActive : style.menuItem } > <p> GHE - EXAMES </p></div>
                    )}
                </NavLink>
                <NavLink to="treinamentos-ghe" >
                    {({ isActive }) => (
                        <div className={ isActive ? style.menuItemActive : style.menuItem } > <p> GHE - TREINAMENTOS </p></div>
                    )}
                </NavLink>

                <div className={ style.lineSeparator } ></div>

                <NavLink to="grafico-atend-amb" >
                    {({ isActive }) => (
                        <div className={ isActive ? style.menuItemActive : style.menuItem } > <p> GRÁFICO ATENDIMENTO AMB. </p></div>
                    )}
                </NavLink>
                <NavLink to="grafico-desvios" >
                    {({ isActive }) => (
                        <div className={ isActive ? style.menuItemActive : style.menuItem } > <p> GRÁFICO DESVIOS </p></div>
                    )}
                </NavLink>
                <NavLink to="grafico-insp-campo" >
                    {({ isActive }) => (
                        <div className={ isActive ? style.menuItemActive : style.menuItem } > <p> GRÁFICO INSPEÇÃO DE CAMPO </p></div>
                    )}
                </NavLink>
                <NavLink to="grafico-insp-ma" >
                    {({ isActive }) => (
                        <div className={ isActive ? style.menuItemActive : style.menuItem } > <p> GRÁFICO INSPEÇÃO M.A. </p></div>
                    )}
                </NavLink>
                <NavLink to="grafico-treinamentos" >
                    {({ isActive }) => (
                        <div className={ isActive ? style.menuItemActive : style.menuItem } > <p> GRÁFICO TREINAMENTOS </p></div>
                    )}
                </NavLink>
                <NavLink to="grafico-rema" >
                    {({ isActive }) => (
                        <div className={ isActive ? style.menuItemActive : style.menuItem } > <p> GRÁFICO REMA </p></div>
                    )}
                </NavLink>
            </div>
        </div>
    )

}

export default SidePanel;